/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_NInputs */

const en_tut_rekam_n = /** @type {(inputs: Tut_Rekam_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Things to know first: one recording session lasts at most an hour; the result is kept 30 days; only people who had already joined when recording started can open it — latecomers cannot; if the host disconnects before it finishes, the unfinished recording is discarded; and recordings from a private desk call are deleted as soon as that desk is released or changes hands.`)
};

const id_tut_rekam_n = /** @type {(inputs: Tut_Rekam_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang perlu diketahui sebelum memakainya: satu sesi rekaman maksimal satu jam; hasilnya disimpan 30 hari; yang bisa membukanya hanya peserta yang sudah bergabung saat rekaman dimulai — yang datang belakangan tidak; kalau host terputus sebelum selesai, rekaman yang belum final dibuang; dan rekaman dari panggilan meja pribadi ikut dihapus begitu meja itu dilepas atau berpindah tangan.`)
};

/**
* | output |
* | --- |
* | "Things to know first: one recording session lasts at most an hour; the result is kept 30 days; only people who had already joined when recording started can ..." |
*
* @param {Tut_Rekam_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_n = /** @type {((inputs?: Tut_Rekam_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_n(inputs)
	return en_tut_rekam_n(inputs)
});